import Vue from "vue";

export const ErrorEventBus = new Vue();

export const SuccessEventBus = new Vue();

export const ClearEventBus = new Vue();

export const EventBus = new Vue();
